export const GET_FORM_ITEM_SUCCESS = 'GET_FORM_ITEM_SUCCESS';
export const GET_FORM_ITEM_FAIL = 'GET_FORM_ITEM_FAIL';
export const INIT_FORM_ITEMS = 'INIT_FORM_ITEMS';
